/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import { CSSProperties, useState } from 'react';
import classes from './ImagePreview.module.css'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';

export default function ImagePreview({
    className,
    style,

    images,
    defaultIndex = 0
}: {
    className?: string;
    style?: CSSProperties;

    images: string[];
    defaultIndex?: number;
}) {
  const [thumbsSwiper, setThumbsSwiper] = useState<number>(defaultIndex);

  return (
    <div
        className={`${classes.ImagePreview} ${className}`}
        style={style}
    >
      <Swiper key={thumbsSwiper +'-main-swiper'}
        spaceBetween={10}
        navigation={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className={classes.mySwiper2}
        initialSlide={thumbsSwiper}
        onSlideChange={(swiper) => {
            setThumbsSwiper(swiper.activeIndex);
        }}
      >
          {images.map((image, index) => {
              return (
                    <SwiperSlide key={index + '-main-swiper-slide'}
                        className={classes.slide}
                    >
                        <img src={image} alt="img" 
                            className={classes.img}
                        />
                    </SwiperSlide>
                )
          })}
      </Swiper>
      <Swiper
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        initialSlide={defaultIndex}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className={classes.mySwiper}
      >
        {images.map((image, index) => {
            return (
                <SwiperSlide key={index + '-thumb-swiper-slide'}
                    className={`${classes.slide} ${index === thumbsSwiper ? classes.active : ''}`}
                    onClick={() => setThumbsSwiper(index)}
                >
                    <img src={image} alt="img"
                        className={classes.img}
                    />
                </SwiperSlide>
            )
        })}
      </Swiper>
    </div>
  );
}